// services/businessAreaService.js - Servicio de áreas de negocio
import apiClient from './api';

class BusinessAreaService {
  // Obtener todas las áreas de negocio
  async getAll() {
    try {
      const response = await apiClient.get('/business-areas');
      return { success: true, areas: response.data };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al obtener áreas de negocio';
      return { success: false, error: message };
    }
  }

  // Obtener área de negocio por ID
  async getById(id) {
    try {
      const response = await apiClient.get(`/business-areas/${id}`);
      return { success: true, area: response.data };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al obtener área de negocio';
      return { success: false, error: message };
    }
  }

  // Obtener área de negocio por código
  async getByCode(code) {
    try {
      const response = await apiClient.get(`/business-areas/code/${code}`);
      return { success: true, area: response.data };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al obtener área de negocio';
      return { success: false, error: message };
    }
  }

  // Crear nueva área de negocio
  async create(areaData) {
    try {
      const response = await apiClient.post('/business-areas', areaData);
      return { success: true, area: response.data };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al crear área de negocio';
      return { success: false, error: message };
    }
  }

  // Actualizar área de negocio
  async update(id, areaData) {
    try {
      const response = await apiClient.patch(`/business-areas/${id}`, areaData);
      return { success: true, area: response.data };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al actualizar área de negocio';
      return { success: false, error: message };
    }
  }

  // Eliminar área de negocio
  async delete(id) {
    try {
      await apiClient.delete(`/business-areas/${id}`);
      return { success: true };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al eliminar área de negocio';
      return { success: false, error: message };
    }
  }

  // Activar área de negocio
  async activate(id) {
    try {
      const response = await apiClient.patch(`/business-areas/${id}/activate`);
      return { success: true, area: response.data };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al activar área de negocio';
      return { success: false, error: message };
    }
  }

  // Desactivar área de negocio
  async deactivate(id) {
    try {
      const response = await apiClient.patch(`/business-areas/${id}/deactivate`);
      return { success: true, area: response.data };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al desactivar área de negocio';
      return { success: false, error: message };
    }
  }

  // Obtener conteo de usuarios en área
  async getUsersCount(id) {
    try {
      const response = await apiClient.get(`/business-areas/${id}/users-count`);
      return { success: true, count: response.data };
    } catch (error) {
      const message = error.response?.data?.message || 'Error al obtener conteo de usuarios';
      return { success: false, error: message };
    }
  }
}

// Exportar instancia singleton
const businessAreaService = new BusinessAreaService();
export default businessAreaService; 